import { ProjectMethodology } from 'components/ProjectMethodology';
import type { CatalogItemData } from 'gql/graphql';
import type { TableColumn } from 'uikit';

import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import Styles from '../catalogList.module.css';

interface CatalogItem extends CatalogItemData {
    id: string;
}

export const useCatalogListColumns = () =>
    useMemo<TableColumn<CatalogItem>[]>(
        () => [
            {
                accessor: 'name',
                title: 'Наименование',
                sortable: true,
                renderCell: (row) => (
                    <Link className={Styles.linkName} to={`/catalogs/${row.type.uniqueId}/${row.id}`}>
                        {row.name}
                    </Link>
                ),
            },
            {
                accessor: 'type',
                title: 'Методология',
                renderCell: ({ type }) => (
                    <div className={Styles.methodologies}>
                        {type?.methodologies?.map((methodology) => (
                            <ProjectMethodology key={methodology} methodology={methodology} />
                        ))}
                    </div>
                ),
                width: 256,
            },
            {
                accessor: 'updatedAt',
                title: 'Дата изменения',
                renderCell: (row) => new Date(row.updatedAt).toLocaleDateString(),
                sortable: true,
                width: 256,
            },
            {
                accessor: 'subsidiaryName',
                title: 'Дочернее общество',
                width: 440,
            },
        ],
        [],
    );
